<template>
    <div v-if="blok.big" class="mt-5">&nbsp;</div>
    <div v-else class="mt-4">&nbsp;</div>
</template>

<script>
    export default {
        props: ['blok']
    }
</script>